import type { FaireProductEntity } from "../../entity_types/product";

export const p_3uwtnp8krr: FaireProductEntity = {
  token: "p_3uwtnp8krr",
  type: "product",
  name: "Rose Quartz Face Roller",
  brandToken: "b_1yelunfq",
  brandName: "Beauty By Earth",
  imageUrl:
    "https://cdn.faire.com/fastly/677ee582616ac1877fb67b5d1cc4eea85a5c9f21115db59caa94e6f55331656e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da3e391f72045dc22a7c43f0d3eb0151ee7d0d3e8b3de892ef1d6d3ef6d8fef8.jpeg",
    "https://cdn.faire.com/fastly/27d6f0564ae22d29c7adab4e78ae0d3a07f6059fc7f675af574101ad0e3bd8bf.jpeg",
    "https://cdn.faire.com/fastly/ced189d505dc42ad20e126126a53e3066afa2a43c6f2b6fa3d78dc86196d056f.jpeg",
    "https://cdn.faire.com/fastly/a000692fa8c4a8be4d9184bb0d02c2c4d440cc4ad3e554a81b2e6d8e97ea211d.jpeg",
    "https://cdn.faire.com/fastly/921fae3bbbb0aa5c56fc7201ab8a0b6e7752c2565bb338b039a34ba737aa932d.jpeg",
    "https://cdn.faire.com/fastly/657d022cb7417f1d264d449f3254c6fbf6dad0e8e40107dd1ff9b46ccd9a7272.jpeg",
    "https://cdn.faire.com/fastly/49cae76af7cb394424210b99d4a8ed023c98cc89c0bebcac764f2c6cb82790f6.jpeg",
  ],
  priceDollars: 20.19,
  description:
    "Enhance your daily routine with our naturally soothing quartz roller. High-quality and a joy to use, our roller is the perfect way to show your skin a little extra love. Our rose quartz roller comes in a magnetic gift box and the ideal self-care and relaxation gift for all the natural beauties on your list! \n\n🌿 Always Cruelty Free! \n🌿 High Quality - Doesn't Squeak!\n🌿 Always Cruelty Free! \n🌿 Helps with lymphatic drainage\n🌿 Help press serums and moisturizers into your skin for maximum absorbency and benefit",
  tags: [],
  msrpDollars: 34.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:43.535Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
